"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadTokensForUser = void 0;

var XalInternalError_1 = require("../../errors/XalInternalError");

var XalInternalErrorType_1 = require("../../errors/XalInternalErrorType");

var ITelemetryClient_1 = require("../../ITelemetryClient");

var Utils_1 = require("../../Utils");

var XboxTokenCache_1 = require("../../XboxTokenCache");

var OperationBase_1 = require("../OperationBase");

var StepTracker_1 = require("../StepTracker");

var Step;

(function (Step) {
  Step["Start"] = "Start";
  Step["ReadingTokens"] = "ReadingTokens";
  Step["Done"] = "Done";
})(Step || (Step = {}));

var LoadTokensForUser =
/** @class */
function (_super) {
  __extends(LoadTokensForUser, _super);

  function LoadTokensForUser(telemetryClient, memoryCache, storage, msaUserId, key) {
    var _this = _super.call(this, telemetryClient) || this;

    _this.memoryCache = memoryCache;
    _this.storage = storage;
    _this.msaUserId = msaUserId;
    _this.key = key;
    _this.step = new StepTracker_1.StepTracker(ITelemetryClient_1.Area.LoadTokensForUser, Step.Start);
    return _this;
  }

  LoadTokensForUser.prototype.run = function () {
    return __awaiter(this, void 0, void 0, function () {
      var cachedDisplayClaims, tokensFromMemory, data, error_1, tokens, parsedTokens, displayClaims;

      var _this = this;

      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            cachedDisplayClaims = this.memoryCache.getUserDisplayClaims(this.msaUserId);

            if (cachedDisplayClaims) {
              this.step.advance(Step.Done);
              this.succeed(cachedDisplayClaims);
              return [2
              /*return*/
              ];
            }

            tokensFromMemory = this.memoryCache.getTokensForUser(this.msaUserId);

            if (tokensFromMemory && tokensFromMemory.length > 0) {
              this.step.advance(Step.Done);
              this.fail(new XalInternalError_1.XalInternalError(XalInternalErrorType_1.XalInternalErrorType.NoDisplayClaimsFound, "No display claims found for user"));
              return [2
              /*return*/
              ];
            }

            this.step.advance(Step.ReadingTokens);
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , this.storage.read(this.key)];

          case 2:
            data = _a.sent();
            return [3
            /*break*/
            , 4];

          case 3:
            error_1 = _a.sent();
            Utils_1.xalTrace(Utils_1.TraceLevel.Error, "Failed to read user tokens with error: " + error_1);
            this.step.advance(Step.Done);
            this.fail(new XalInternalError_1.XalInternalError(XalInternalErrorType_1.XalInternalErrorType.NoUserFound, "Failed to read user tokens"));
            return [2
            /*return*/
            ];

          case 4:
            Utils_1.assert(this.step.currentStep === Step.ReadingTokens);

            if (Utils_1.isNullOrWhiteSpace(data)) {
              Utils_1.xalTrace(Utils_1.TraceLevel.Important, "No data was found for the user");
              this.step.advance(Step.Done);
              this.fail(new XalInternalError_1.XalInternalError(XalInternalErrorType_1.XalInternalErrorType.NoUserFound, "No data was found for the user"));
              return [2
              /*return*/
              ];
            }

            tokens = [];

            try {
              parsedTokens = XboxTokenCache_1.parseMultipleTokenBlob(data, this.memoryCache.deviceIdentity.uniqueId);
              tokens = parsedTokens ? parsedTokens : [];
            } catch (error) {
              Utils_1.xalTrace(Utils_1.TraceLevel.Warning, "Failed to deserialize user tokens: " + error);
              this.step.advance(Step.Done);
              this.fail(new XalInternalError_1.XalInternalError(XalInternalErrorType_1.XalInternalErrorType.NoUserFound, "Failed to deserialize user tokens"));
              return [2
              /*return*/
              ];
            }

            displayClaims = tokens.find(function (token) {
              return token.hasSignInDisplayClaims;
            });
            tokens.forEach(function (token) {
              return _this.memoryCache.insertToken(token);
            });

            if (displayClaims) {
              this.step.advance(Step.Done);
              this.succeed(displayClaims);
              return [2
              /*return*/
              ];
            } else {
              Utils_1.xalTrace(Utils_1.TraceLevel.Warning, "No token with display claims found");
              this.step.advance(Step.Done);
              this.fail(new XalInternalError_1.XalInternalError(XalInternalErrorType_1.XalInternalErrorType.NoDisplayClaimsFound, "No token with display claims found"));
              return [2
              /*return*/
              ];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return LoadTokensForUser;
}(OperationBase_1.OperationBase);

exports.LoadTokensForUser = LoadTokensForUser;